export const PromotionRocketCustomersDataUSA5Percent = [
    '000415240',
    '000417680',
    '000432520',
    '000434103',
    '000425928',
    '000422897',
    '000421862',
    '000419330',
    '000421702',
    '000419304',
    '000419378',
    '000419495',
    '000419531',
    '000419450',
    '000427116',
    '000419459',
    '000419412',
    '000419259',
    '000419506',
    '000419318',
    '000436265',
    '000419391',
    '000419221',
    '000433132',
    '000419339',
    '000419439',
    '000432309',
    '000419498',
    '000429922',
    '000419214',
    '000430894',
    '000431920',
    '000410457',
    '000431181',
    '000411026',
    '000411342',
    '000412388',
    '000412373',
    '000422135',
    '000428409',
    '000409725',
    '000410673',
    '000423630',
    '000412681',
    '000426505',
    '000416374',
    '000409185',
    '000411189',
    '000436826',
    '000429861',
    '000409531',
    '000422817',
    '000431866',
    '000423435',
    '000417220',
    '000417363',
    '000410897',
    '000409056',
    '000425717',
    '000433752',
    '000411127',
    '000417058',
    '000416792',
    '000412200',
    '000420382',
    '000414338',
    '000408814',
    '000418253',
    '000420118',
    '000418365',
    '000418294',
    '000418987',
    '000423146',
    '000420300',
    '000428417',
    '000418902',
    '000428190',
    '000428284',
    '000418480',
    '000420642',
    '000418569',
    '000418577',
    '000425576',
    '000430457',
    '000431700',
    '000434914',
    '000419855',
    '000419989',
    '000418467',
    '000429797',
    '000429774',
    '000418565',
    '000418515',
    '000418486',
    '000418497',
    '000419816',
    '000419733',
    '000419871',
    '000419918',
    '000423641',
    '000419669',
    '000419788',
    '000116576',
    '000419703',
    '000428725',
    '000419673',
    '000419675',
    '000425642',
    '000424400',
    '000421957',
    '000430698',
    '000419554',
    '000419810',
    '000432424',
    '000419617',
    '000419657',
    '000419708',
    '000419663',
    '000422175',
    '000430860',
    '000419982',
    '000420451',
    '000426241',
    '000419654',
    '000431283',
    '000424107',
    '000420120',
    '000426963',
    '000423791',
    '000430225',
    '000431419',
    '000420771',
    '000436753',
    '000423301',
    '000430360',
    '000431703',
    '000430459',
    '000432080',
    '000423512',
    '000430037',
    '000423405',
    '000436649',
    '000436886',
    '000423766',
    '000420351',
    '000418752',
    '000428326',
    '000418207',
    '000430549',
    '000432200',
    '000426833',
    '000432969',
    '000417234',
    '000414705',
    '000415731',
    '000423372',
    '000416266',
    '000417983',
    '000413953',
    '000409504',
    '000417972',
    '000430153',
    '000428206',
    '000432585',
    '000431773',
    '000432689',
    '000411804',
    '000424898',
    '000416748',
    '000415903',
    '000416983',
    '000416401',
    '000430220',
    '000429503',
    '000415464',
    '000422712',
    '000421238',
    '000425679',
    '000413646',
    '000413582',
    '000417204',
    '000423375',
    '000423525',
    '000433238',
    '000431301',
    '000422993',
    '000422856',
    '000424711',
    '000412710',
    '000423076',
    '000422715',
    '000424876',
    '000434410',
    '000432867',
    '000422731',
    '000435432',
    '000409662',
    '000414001',
    '000412341',
    '000417191',
    '000416280',
    '000412452',
    '000410792',
    '000410447',
    '000432275',
    '000432267',
    '000412357',
    '000414189',
    '000415737',
    '000419287',
    '000419535',
    '000419203',
    '000420800',
    '000433501',
    '000409176',
    '000411307',
    '000418743',
    '000415001',
    '000428164',
    '000434340',
    '000413578',
    '000428158',
    '000413523',
    '000427320',
    '000430100',
    '000429719',
    '000426426',
    '000431865',
    '000420105',
    '000427202',
    '000410982',
    '000432129',
    '000411385',
    '000430329',
    '000425931',
    '000431597',
    '000431074',
    '000423091',
    '000428564',
    '000415886',
    '000412837',
    '000435120',
    '000434967',
    '000418315',
    '000434886',
    '000423376',
    '000421357',
    '000424604',
    '000420727',
    '000425322',
    '000426912',
    '000420803',
    '000417254',
    '000424130',
    '000424510',
    '000424394',
    '000423799',
    '000415838',
    '000434462',
    '000414741',
    '000423618',
    '000415492',
    '000428041',
    '000421293',
    '000425927',
    '000421635',
    '000423765',
    '000421306',
    '000420905',
    '000416939',
    '000431141',
    '000416163',
    '000414836',
    '000415347',
    '000413547',
    '000435776',
    '000431171',
    '000428386',
    '000417970',
    '000414848',
    '000413354',
    '000434542',
    '000435475',
    '000430083',
    '000437899',
    '000423425',
    '000429075',
    '000413620',
    '000423056',
    '000439894',
    '000433863',
    '000432681',
    '000437600',
    '000440163',
    '000440120',
    '000440082',
    '000440207',
    '000436259',
    '000427655',
    '000439831',
    '000414067',
    '000423694',
    '000436093',
    '000425649',
    '000440380',
    '000412158',
    '000440170',
    '000438948',
    '000417652',
    '000440910',
    '000428453',
    '000412366',
    '000420175',
    '000440359',
    '000440994',
    '000415305',
    '000437699',
    '000420014',
    '000412783',
    '000426171',
    '000438222',
    '000441021',
    '000440906',
    '000428195',
    '000441131',
    '000441261',
    '000441250',
    '000420140',
    '000440425',
    '000441513',
    '000438130',
    '000438513',
    '000440705',
    '000440117',
    '000441196',
    '000431112',
    '000441187',
    '000431705',
    '000429314',
    '000416300',
    '000427457',
    '000419607',
    '000428214',
    '000432366',
    '000436636',
    '000437927',
    '000410421',
    '000436878',
    '000426509',
    '000431806',
    '000441491',
    '000411131',
    '000433740',
    '000438962',
    '000442003',
    '000433066',
    '000441708',
    '000410680',
    '000415947',
    '000441868',
    '000440273',
    '000427050',
    '000442153',
    '000420674',
    '000431988',
    '000439928',
    '000418905',
    '000429148',
    '000442530',
    '000442501',
    '000433406',
    '000420141',
    '000415947',
    '000452478',
    '000442350',
    '000415623',
    '000452589',
    '000420119',
    '000417306',
    '000452629',
    '000452922',
    '000409502',
    '000438496',
    '000426664',
    '000419928',
    '000428358',
    '000422860',
    '000434218',
    '000409142',
    '000420670',
    '000437215',
    '000440354',
    '000453461',
    '000415033',
    '000442326',
    '000429259',
    '000453436',
    '000421342',
    '000426117',
    '000437044',
    '000453988',
    '000434327',
    '000454175',
    '000454157',
    '000435488',
    '000453155',
    '000454278',
    '000454292',
    '000436828',
    '000454268',
    '000454279',
    '000418553',
    '000416812',
    '000452750',
    '000454587',
    '000427590',
    '000424143',
    '000411677',
    '000414035',
    '000409263',
    '000411623',
    '000417080',
    '000414072',
    '000431956',
    '000414738',
    '000426382',
    '000429591',
    '000428472',
    '000419231',
    '000418052',
    '000408926',
    '000430347',
    '000418305',
    '000418006',
    '000419270',
    '000420359',
    '000422133',
    '000423934',
    '000416460',
    '000428463',
    '000426205',
    '000417275',
    '000414867',
    '000421097',
    '000433861',
    '000409818',
    '000434285',
    '000417369',
    '000429752',
    '000417993',
    '000414373',
    '000409600',
    '000409805',
    '000428779',
    '000408833',
    '000417742',
    '000412784',
    '000423485',
    '000414830',
    '000411988',
    '000412982',
    '000410404',
    '000412877',
    '000431079',
    '000409046',
    '000431174',
    '000423810',
    '000431264',
    '000410788',
    '000429720',
    '000414984',
    '000410228',
    '000419263',
    '000432640',
    '000436356',
    '000428360',
    '000415608',
    '000409994',
    '000425963',
    '000416644',
    '000429513',
    '000425172',
    '000410574',
    '000426968',
    '000416696',
    '000420236',
    '000414981',
    '000426144',
    '000426042',
    '000424756',
    '000415203',
    '000428078',
    '000430769',
    '000418299',
    '000418215',
    '000420452',
    '000420170',
    '000422155',
    '000418344',
    '000420511',
    '000412528',
    '000430117',
    '000420084',
    '000413895',
    '000413626',
    '000432564',
    '000414536',
    '000416426',
    '000412892',
    '000421287',
    '000423427',
    '000418241',
    '000417087',
    '000410217',
    '000415999',
    '000424165',
    '000417999',
    '000411951',
    '000410235',
    '000417116',
    '000410863',
    '000425535',
    '000417344',
    '000410189',
    '000410407',
    '000424215',
    '000410837',
    '000412170',
    '000429624',
    '000412139',
    '000410298',
    '000410832',
    '000416161',
    '000423179',
    '000411611',
    '000429415',
    '000418419',
    '000417123',
    '000412048',
    '000414959',
    '000415446',
    '000415264',
    '000409543',
    '000411918',
    '000411593',
    '000415179',
    '000411401',
    '000412231',
    '000434169',
    '000413452',
    '000418696',
    '000414038',
    '000412583',
    '000409469',
    '000411231',
    '000412605',
    '000410427',
    '000427100',
    '000421884',
    '000409880',
    '000417057',
    '000412310',
    '000425563',
    '000411373',
    '000435485',
    '000432636',
    '000410398',
    '000115488',
    '000417226',
    '000411485',
    '000411458',
    '000410908',
    '000424309',
    '000426523',
    '000413660',
    '000428681',
    '000417880',
    '000429466',
    '000418903',
    '000431706',
    '000414924',
    '000430475',
    '000409236',
    '000411148',
    '000412737',
    '000428519',
    '000417863',
    '000435216',
    '000420525',
    '000416558',
    '000411050',
    '000417877',
    '000428985',
    '000416756',
    '000414718',
    '000414215',
    '000417580',
    '000418230',
    '000418030',
    '000426895',
    '000410218',
    '000423884',
    '000412172',
    '000417901',
    '000412365',
    '000410027',
    '000412799',
    '000412669',
    '000411218',
    '000417864',
    '000409332',
    '000423579',
    '000412414',
    '000431261',
    '000412242',
    '000414795',
    '000410755',
    '000411687',
    '000410251',
    '000423887',
    '000412894',
    '000433589',
    '000414759',
    '000414735',
    '000428661',
    '000421768',
    '000412377',
    '000432394',
    '000422639',
    '000414348',
    '000427576',
    '000427138',
    '000422771',
    '000413801',
    '000413800',
    '000426126',
    '000424173',
    '000431352',
    '000410968',
    '000422886',
    '000413008',
    '000428552',
    '000422207',
    '000421744',
    '000424910',
    '000422708',
    '000423580',
    '000417651',
    '000417625',
    '000415140',
    '000430464',
    '000429475',
    '000415704',
    '000412971',
    '000427695',
    '000414577',
    '000409583',
    '000409410',
    '000424927',
    '000413100',
    '000413636',
    '000426617',
    '000415339',
    '000413321',
    '000432880',
    '000428143',
    '000413184',
    '000417591',
    '000413138',
    '000426616',
    '000413549',
    '000410188',
    '000410444',
    '000417317',
    '000409664',
    '000411340',
    '000429217',
    '000411294',
    '000411276',
    '000415110',
    '000417149',
    '000431250',
    '000434449',
    '000411056',
    '000423997',
    '000420047',
    '000424475',
    '000420813',
    '000414898',
    '000419492',
    '000427033',
    '000419261',
    '000424806',
    '000408894',
    '000415862',
    '000410998',
    '000409080',
    '000411944',
    '000427623',
    '000413463',
    '000425325',
    '000428341',
    '000431485',
    '000427006',
    '000422780',
    '000409460',
    '000414646',
    '000431058',
    '000410661',
    '000427545',
    '000427510',
    '000411441',
    '000416121',
    '000422316',
    '000412425',
    '000432796',
    '000409208',
    '000410181',
    '000411372',
    '000410754',
    '000411123',
    '000411930',
    '000428639',
    '000424945',
    '000425351',
    '000435683',
    '000409261',
    '000412537',
    '000412845',
    '000425122',
    '000410115',
    '000412577',
    '000411881',
    '000432909',
    '000409813',
    '000411404',
    '000426751',
    '000410474',
    '000423120',
    '000411978',
    '000409175',
    '000412954',
    '000412470',
    '000430896',
    '000424776',
    '000430159',
    '000430542',
    '000412763',
    '000431232',
    '000430810',
    '000425569',
    '000412196',
    '000409979',
    '000411095',
    '000427188',
    '000423946',
    '000410781',
    '000428525',
    '000412300',
    '000416857',
    '000416739',
    '000413790',
    '000429190',
    '000409565',
    '000436522',
    '000409589',
    '000432980',
    '000418434',
    '000424316',
    '000415410',
    '000425394',
    '000411813',
    '000412879',
    '000410482',
    '000416328',
    '000428062',
    '000430145',
    '000432635',
    '000414401',
    '000424998',
    '000419070',
    '000415784',
    '000416056',
    '000416453',
    '000416528',
    '000415277',
    '000428067',
    '000428278',
    '000414633',
    '000415403',
    '000415565',
    '000420964',
    '000414352',
    '000428915',
    '000434916',

]